import { useState } from "react";

import PS from "../../PlantList/MonitoringApiService";

export const useFetchMonitoring = () => {
  const [ value, setValue ] = useState("");
  const [ isLoading, setIsLoading ] = useState(false);
  const [ response, setResponse ] = useState({});
  const [ error, setError ] = useState({
    isError: false,
    errorMessage: null,
  });
  const [ param, setParam ] = useState({
    packet: value,
  });

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError({
      isError: false,
      errorMessage: null,
    });
    setResponse({});
    setParam({
      packet: value,
    });
    try {
      const res = await PS.getTestTool({ packet: value });

      setResponse(res);
    } catch (error) {
      setError({
        isError: true,
        errorMessage: error,
      });
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    value,
    handleChange,
    handleSubmit,
    isLoading,
    response,
    error,
    param,
  }
}